<!--div class="container-main">
    <app-header></app-header>
    <div class="divSpace"></div>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div-->
<div class="container-main">
  <!-- Overlay de rate limiting - se muestra por encima de todo cuando hay bloqueo -->
  <app-rate-limit-overlay></app-rate-limit-overlay>

  <!-- Header siempre visible -->
  <app-header></app-header>

  <!-- Contenido principal - se oculta cuando hay rate limiting activo -->
  <div *ngIf="!rateLimitActive" class="main-content">
    <router-outlet></router-outlet>
    <app-contacto></app-contacto>
  </div>

  <!-- Footer siempre visible -->
  <app-footer></app-footer>
  <!--app-galeria></app-galeria-->
  <!--app-fotografia-detalle></app-fotografia-detalle-->
</div>
